var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 26,
    rx: 4.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 26,
    rx: 4.5,
    stroke: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7C20.5938 7 21.5 7.90625 21.5 9V19C21.5 20.125 20.5938 21 19.5 21H7.5C6.375 21 5.5 20.125 5.5 19V9C5.5 7.90625 6.375 7 7.5 7H19.5ZM9 19.5V16.75H7V19C7 19.2812 7.21875 19.5 7.5 19.5H9ZM9 15.25V12.75H7V15.25H9ZM9 11.25V8.5H7.5C7.21875 8.5 7 8.75 7 9V11.25H9ZM16.5 19.5V14.75H10.5V19.5H16.5ZM16.5 13.25V8.5H10.5V13.25H16.5ZM20 19V16.75H18V19.5H19.5C19.75 19.5 20 19.2812 20 19ZM20 15.25V12.75H18V15.25H20ZM20 11.25V9C20 8.75 19.75 8.5 19.5 8.5H18V11.25H20Z",
    fill: "#6F6B7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm);
export default __webpack_public_path__ + "static/media/film.5e680b19d2ef3b76bbce72eca5e8fcf6.svg";
export { ForwardRef as ReactComponent };